import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("smm_lang") || "en");
    const [theme, setTheme] = useState(() => localStorage.getItem("smm_theme") || "light");

    useEffect(() => {
        document.documentElement.classList.toggle("dark", theme === "dark");
        localStorage.setItem("smm_theme", theme);
    }, [theme]);

    useEffect(() => {
        localStorage.setItem("smm_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = translations[lang] || translations.en;
    const toggleLang = () => setLang(lang === "en" ? "te" : "en");
    const toggleTheme = () => setTheme(theme === "dark" ? "light" : "dark");

    return (
        <AppContext.Provider value={{ lang, setLang, toggleLang, theme, toggleTheme, t }}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);
